export default "__VITE_ASSET__D$a8Midp__"